import React, { useState, useEffect } from 'react';
import {
  Position,
  useEdges,
  useReactFlow,
  useUpdateNodeInternals
} from '@xyflow/react';
import { useTrashNode } from './commons/trashNode';
import { FlowHandle } from './commons/flowHandle';
import { UilTrashAlt } from '@iconscout/react-unicons';
import SimpleLabelTextBox from 'pub-components/ui-controls/ui-components/SimpleLabelTextbox';
import ApiNodeSidebar from '../sidebars/ApiNodeSidebar';
import { Button } from 'react-bootstrap';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';

const ApiNode = ({ id, data, editable = true, handleNodeApiAddTransition }) => {
  const { setNodes, setEdges } = useReactFlow();
  const trashNode = useTrashNode();
  const edges = useEdges();
  // Track transition being added
  const [pendingTransition, setPendingTransition] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const updateNodeInternals = useUpdateNodeInternals();

  const method = data.apiMethod || 'GET';
  const url = data.apiUrl || '';
  console.log(data);
  const DEFAULT_TRANSITIONS = [
    { id: `transition-${id}-0`, value: 'Success' },
    { id: `transition-${id}-1`, value: 'Failure' }
  ];

  const [items] = useState(
    data?.transitions?.length ? data.transitions : DEFAULT_TRANSITIONS
  );

  useEffect(() => {
    updateNodeInternals(id);
  }, []);

  const onChange = newData => {
    setNodes(nds =>
      nds.map(node =>
        node.id === id ? { ...node, data: { ...node.data, ...newData } } : node
      )
    );
  };

  const IsValidConnection = connection => {
    // limit 1 connection per source handle
    if (edges.some(edge => edge.sourceHandle === connection.sourceHandle))
      return false;

    return true;
  };

  useEffect(() => {
    if (!data?.transitions || data.transitions.length === 0) {
      onChange({ ...data, transitions: items });
    }
  }, []);

  return (
    <dl className="mt-3" style={{ width: '300px' }}>
      <FlowHandle
        type="target"
        position={Position.Left}
        id={`${id}-target`}
        editable={editable}
        isConnectable={true}
      />
      <div
        className="card border-success shadow-sm rounded-10"
        style={{ backgroundColor: '#F9F9F9' }}
      >
        <div
          className="d-flex align-items-center px-4 api-header"
          style={{ backgroundColor: '#FFF4E5' }}
        >
          <div className="d-flex mr-auto ml-2">
            <dt
              className="text-truncate fw-semibold fs-6"
              style={{ color: '#7D5500' }}
            >
              API Node
            </dt>
          </div>
          <div className="d-flex ms-auto">
            <button
              onClick={() => {
                setPendingTransition(null);
                setOpenEdit(true);
              }}
              className="d-flex align-items-center rounded-circle p-2 header-delete-icon"
              title="Edit API"
              disabled={!editable}
            >
              <UilPen
                style={{ width: '24px', height: '24px', color: '#6B7280' }}
              />
            </button>

            <button
              onClick={e => trashNode(e, id)}
              className="d-flex align-items-center rounded-circle p-2 header-delete-icon"
              title="Delete api"
              disabled={!editable}
            >
              <UilTrashAlt
                style={{ width: '24px', height: '24px', color: '#dc3545' }}
              />
            </button>
          </div>
        </div>

        <div className="card-body p-2">
          <div className="small mb-2">
            <strong>{method}</strong>
          </div>
          {url && (
            <div className="small text-muted text-truncate" title={url}>
              {url}
            </div>
          )}
          {/* Transitions */}
          <div className="px-4 pb-3" style={{ marginBottom: '10px' }}>
            {items.length > 0 && (
              <div>
                <dt
                  className="text-truncate small fw-medium mt-3 px-4"
                  style={{
                    color: '#6B7280',
                    fontWeight: '600',
                    fontSize: '16px'
                  }}
                >
                  Transition
                </dt>
                <div>
                  {items != null &&
                    items?.map((item, index) => (
                      <div
                        key={item.id}
                        className="d-flex align-items-center gap-2 position-relative mb-2"
                      >
                        <SimpleLabelTextBox
                          dataProperty={item.value}
                          editable={false}
                          // handleChange={e => updateItem(index, e.target.value)}
                          placeholder="Transition"
                          inputStyles={{
                            backgroundColor: 'white'
                          }}
                          inputPropStyle={{ padding: '10px' }}
                          styles={{ flex: 1 }}
                        />
                        <FlowHandle
                          type="source"
                          position={Position.Right}
                          id={item.id}
                          style={{
                            right: '-13px',
                            top: '50%'
                          }}
                          editable={editable}
                          title={item.value}
                          isValidConnection={IsValidConnection}
                          isConnectable={true}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
            <ApiNodeSidebar
              open={openEdit}
              setOpen={setOpenEdit}
              nodeId={data.id}
              data={data}
              // items={items}
              // setItems={setItems}
              onChange={patch => onChange(patch)}
              pendingTransition={pendingTransition}
              setPendingTransition={setPendingTransition}
            />
          </div>
        </div>
      </div>
    </dl>
  );
};

export default ApiNode;
